declare global {
  interface Window {
    webkitAudioContext?: typeof AudioContext;
  }
}

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioContext) {
    const AudioContextConstructor =
      window.AudioContext ?? window.webkitAudioContext;
    if (!AudioContextConstructor) {
      throw new Error("AudioContext is not available");
    }
    audioContext = new AudioContextConstructor();
  }
  return audioContext;
}

export function playEventReminderSound(): void {
  try {
    const context = getAudioContext();

    // Helper to create a marimba-like tone
    const playMarimbaNote = (
      startTime: number,
      frequency: number,
      duration = 0.25
    ) => {
      const osc = context.createOscillator();
      const gain = context.createGain();
      const filter = context.createBiquadFilter();

      // Slightly soften the tone
      osc.type = "sine";
      filter.type = "lowpass";
      filter.frequency.value = 2000;

      // Subtle inharmonic overtone for marimba texture
      const overtone = context.createOscillator();
      overtone.type = "sine";
      overtone.frequency.value = frequency * 1.5;

      // Envelope (quick attack, short decay)
      gain.gain.setValueAtTime(0, startTime);
      gain.gain.linearRampToValueAtTime(0.25, startTime + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);

      // Routing
      osc.connect(filter);
      overtone.connect(filter);
      filter.connect(gain);
      gain.connect(context.destination);

      osc.start(startTime);
      overtone.start(startTime);
      osc.stop(startTime + duration);
      overtone.stop(startTime + duration);
    };

    const now = context.currentTime;

    // “Soft Marimba B” — D5 (587.33 Hz) then A5 (880 Hz)
    playMarimbaNote(now, 587.33, 0.25);
    playMarimbaNote(now + 0.18, 880, 0.25);
  } catch (error) {
    window.console.error("Failed to play event reminder sound:", error);
  }
}
